/**
 * Keyclic API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.24.5
 * Contact: techies@keyclic.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MemberPagination } from '../model/memberPagination';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { MembershipServiceInterface }                            from './membership.serviceInterface';


@Injectable()
export class MembershipService implements MembershipServiceInterface {

    protected basePath = 'https://api.keyclic.com';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Retrieve all Membership resources.
     * 
     * @param x_keyclic_app 
     * @param person The identifier of the resource formatted as GUID string.
     * @param accept_language 
     * @param x_keyclic_app_version 
     * @param page Page of the overview.
     * @param limit Page of the overview.
     * @param order 
     * @param after 
     * @param before 
     * @param search_familyName 
     * @param search_givenName 
     * @param search_jobTitle 
     * @param search_username 
     * @param search_email 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cgetMembershipsByPerson(x_keyclic_app: string, person: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, search_familyName?: string, search_givenName?: string, search_jobTitle?: string, search_username?: string, search_email?: string, observe?: 'body', reportProgress?: boolean): Observable<MemberPagination>;
    public cgetMembershipsByPerson(x_keyclic_app: string, person: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, search_familyName?: string, search_givenName?: string, search_jobTitle?: string, search_username?: string, search_email?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MemberPagination>>;
    public cgetMembershipsByPerson(x_keyclic_app: string, person: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, search_familyName?: string, search_givenName?: string, search_jobTitle?: string, search_username?: string, search_email?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MemberPagination>>;
    public cgetMembershipsByPerson(x_keyclic_app: string, person: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, search_familyName?: string, search_givenName?: string, search_jobTitle?: string, search_username?: string, search_email?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (x_keyclic_app === null || x_keyclic_app === undefined) {
            throw new Error('Required parameter x_keyclic_app was null or undefined when calling cgetMembershipsByPerson.');
        }
        if (person === null || person === undefined) {
            throw new Error('Required parameter person was null or undefined when calling cgetMembershipsByPerson.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (order !== undefined && order !== null) {
            queryParameters = queryParameters.set('order', <any>order);
        }
        if (after !== undefined && after !== null) {
            queryParameters = queryParameters.set('after', <any>after.toISOString());
        }
        if (before !== undefined && before !== null) {
            queryParameters = queryParameters.set('before', <any>before.toISOString());
        }
        if (search_familyName !== undefined && search_familyName !== null) {
            queryParameters = queryParameters.set('search[familyName]', <any>search_familyName);
        }
        if (search_givenName !== undefined && search_givenName !== null) {
            queryParameters = queryParameters.set('search[givenName]', <any>search_givenName);
        }
        if (search_jobTitle !== undefined && search_jobTitle !== null) {
            queryParameters = queryParameters.set('search[jobTitle]', <any>search_jobTitle);
        }
        if (search_username !== undefined && search_username !== null) {
            queryParameters = queryParameters.set('search[username]', <any>search_username);
        }
        if (search_email !== undefined && search_email !== null) {
            queryParameters = queryParameters.set('search[email]', <any>search_email);
        }

        let headers = this.defaultHeaders;
        if (accept_language !== undefined && accept_language !== null) {
            headers = headers.set('accept-language', String(accept_language));
        }
        if (x_keyclic_app !== undefined && x_keyclic_app !== null) {
            headers = headers.set('x-keyclic-app', String(x_keyclic_app));
        }
        if (x_keyclic_app_version !== undefined && x_keyclic_app_version !== null) {
            headers = headers.set('x-keyclic-app-version', String(x_keyclic_app_version));
        }

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/hal+json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=UTF-8'
        ];

        return this.httpClient.get<MemberPagination>(`${this.basePath}/people/${encodeURIComponent(String(person))}/memberships`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
